import { render, staticRenderFns } from "./LMSActivities.vue?vue&type=template&id=5e9753f2&"
import script from "./LMSActivities.vue?vue&type=script&lang=js&"
export * from "./LMSActivities.vue?vue&type=script&lang=js&"
import style0 from "./LMSActivities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports